import { render, staticRenderFns } from "./Entrepreneurship.vue?vue&type=template&id=55979ada&scoped=true&"
import script from "./Entrepreneurship.vue?vue&type=script&lang=js&"
export * from "./Entrepreneurship.vue?vue&type=script&lang=js&"
import style0 from "./Entrepreneurship.vue?vue&type=style&index=0&id=55979ada&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55979ada",
  null
  
)

export default component.exports